import MessageFormContainer from './message_form_container';

const MessageForm = MessageFormContainer;
export default MessageForm;
